import EventEmitter from 'events';
import { NETWORK_CONDITION, NETWORK_CONDITION_REASON } from '../../../helpers/networkConditionConstants';

const createNetworkConditionStateMachine = (deps = {}) => {
  const ee = new EventEmitter();
  const { processStats } = deps;

  let networkCondition = NETWORK_CONDITION.GOOD;
  let networkConditionReason = NETWORK_CONDITION_REASON.NONE;

  return Object.assign(ee, {
    setNetworkCondition(ev) {
      networkConditionReason = ev.networkConditionReason;
      if (networkCondition !== ev.networkCondition) {
        networkCondition = ev.networkCondition;
        ee.emit('networkConditionChanged', { reason: 'networkConditionChanged', statsContainer: ev.stats && processStats?.(ev.stats) });
      }
    },
    getTransportStats() {
      return {
        networkCondition,
        networkConditionReason,
      };
    },
  });
};

export default createNetworkConditionStateMachine;
